import { useEffect } from "react";

import type { ChildProps } from "@/types";

import { useThemeStore } from "@/store";

/**
 * Saqlangan mavzuni `<html class="dark">` ga bog'laydi.
 *
 * Birinchi bo'yash `index.html` dagi kichik skript bilan hal qilingan —
 * bu yerdagi effekt faqat KEYINGI o'zgarishlar uchun.
 */
export const ThemeProvider = ({ children }: ChildProps) => {
  const theme = useThemeStore(state => state.theme);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  return <>{children}</>;
};
